<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Review tag | Update creatives</modal-header>
        </div>
        Are you sure you want to update the creatives on this tag to be the latest versions? <br>
        Refresh costs will be applicable to each updated unit.
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, update the creatives."/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {tagMixin} from '@/mixins/tagMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'modal_tag_confirm',
  mixins: [tagMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    updateStatus: Function
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.refreshTag(this.confirmId).then(() => {
        if (this.$route.params.id) {
          this.getAllTagsCreative(this.$route.params.id).then(() => {
            this.finishLoading()
            this.addNotification('success', 'Tag Group updated')
          }, error => {
            this.finishLoading()
            this.addNotification('danger', error)
          })
        } else {
          this.getTags().then(() => {
            this.finishLoading()
            this.addNotification('success', 'Tag Group updated')
          }, error => {
            this.finishLoading()
            this.addNotification('danger', error)
          })
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      if (this.$route.params.id) {
        this.updateStatus(true)
      }
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal/tags/modal-refresh-tag.vue